import React, { Fragment } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Typography from "@material-ui/core/Typography";
import PollIcon from "@material-ui/icons/Poll";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import CircularProgress from "@material-ui/core/CircularProgress";

import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import { LineChart, Line, Tooltip, XAxis } from "recharts";
import { ReactComponent as XlsxIcon } from './xlsx.svg';
import MUITooltip from "@material-ui/core/Tooltip";
import LibraryIcon from '@material-ui/icons/LocalLibraryOutlined';
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import AccountFilter from './AccountFilter.js';
import { apiurl } from '../app/prefs.js';

import { Popover, Paper, Dialog, DialogContent } from "@material-ui/core";

const VideoIcon = (props) => (
  <svg
    style={{ ...props.style }}
    class="svg-icon"
    width='26px'
    height='26px'
    color='#0b6471'
    viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M725.333333 574.506667l170.666667 113.770666V335.722667l-170.666667 113.770666v125.013334z m0-227.562667l189.653334-126.442667C943.36 201.6 981.333333 221.930667 981.333333 256v512c0 34.069333-37.973333 54.4-66.346666 35.498667L725.333333 677.056v48.106667C725.333333 784.085333 677.504 832 618.752 832H149.248A106.666667 106.666667 0 0 1 42.666667 725.162667V298.837333C42.666667 239.914667 90.496 192 149.248 192h469.504A106.666667 106.666667 0 0 1 725.333333 298.837333v48.106667zM128 298.837333v426.325334A21.333333 21.333333 0 0 0 149.248 746.666667h469.504c11.584 0 21.248-9.685333 21.248-21.504V298.837333A21.333333 21.333333 0 0 0 618.752 277.333333H149.248C137.664 277.333333 128 287.018667 128 298.837333z" fill="#0b6471" /></svg>
);

const PlayIcon = () => (
  <svg width="40px" height="40px" viewBox="-1 0 14 14" id="meteor-icon-kit__solid-play-s" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.00154V13.0015C0 13.7788 0.84797 14.259 1.5145 13.859L11.5145 7.859C12.1618 7.4706 12.1618 6.5325 11.5145 6.1441L1.5145 0.14405C0.84797 -0.25586 0 0.22425 0 1.00154z" fill="#758CA3"></path></g></svg>
);

//Cost Per Day Report
const ExpandIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20"
    style={{ transition: 'rotate 0.1s', ...props.style }}
  >
    <title>
      expand
    </title>
    <path d="M19 6.25l-1.5-1.5-7.5 7.5-7.5-7.5L1 6.25l9 9 9-9z" />
  </svg>
)

function format(n) {
  var parts = Number(n) || 0;
  parts = parts.toString().split(".");
  const numberPart = parts[0];
  const decimalPart =
    parts[1] && Math.round(parts[1] / Math.pow(10, parts[1].length - 2));
  const thousands = /\B(?=(\d{3})+(?!\d))/g;
  return (
    numberPart.replace(thousands, "\xa0") +
    (decimalPart ? "," + decimalPart : "")
  );
}

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip-procedures">
        <p className="label-procedures">{`${label}:`}</p>
        <p className="value-procedures">{`${format(payload[0].value)}`}</p>
      </div>
    );
  }
  return null;
};

const InLineChart = (props) => {
  const CustomizedDot = (props) => {
    const { cx, cy, value } = props;

    return (
      <svg
        x={cx - 3}
        y={cy}
        width={6}
        height={2}
        fill={value === 0 ? "#b1b1b1" : value > 0 ? "#7a7a7a" : "#FE8E3C"}
        viewBox="0 0 6 2"
      >
        <rect width="6" height="2" />
      </svg>
    );
  };
  const convertMonths = (input) => {
    const roman = [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12"
    ];
    return Array.isArray(input)
      ? input.map((m, i) => {
        return { m: roman[i], v: m || 0 };
      })
      : [];
  };

  const data = convertMonths(props.data);

  return (
    <LineChart
      style={{ marginLeft: "15px" }}
      syncId={props.id}
      width={100}
      height={25}
      data={data}
    >
      <XAxis hide dataKey="m" />
      <Tooltip
        wrapperStyle={{ backgroundColor: "white", zIndex: 1 }}
        cursor={{ stroke: "orange", fill: "transparent", strokeWidth: "1px" }}
        content={<CustomTooltip />}
        allowEscapeViewBox={{ x: true, y: true }}
      />
      <Line
        type="linear"
        isAnimationActive={false}
        dot={<CustomizedDot />}
        dataKey="v"
        stroke="gray"
        strokeWidth={0}
      ></Line>
    </LineChart>
  );
};

function ProceduresSummary(props) {
  const { row } = props;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [expandedRows, setExpandedRows] = React.useState([]);

  React.useEffect(
    () => {
      setPage(0)
    }, [row]
  );
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const switchExpandedState = (id) => {
    let temp = expandedRows.map(i => i);
    if (temp.includes(id)) {
      temp = temp.filter(i => i !== id)
    } else {
      temp.push(id)
    }
    setExpandedRows(temp);
  };

  return (
    <Paper
      style={{
        minWidth: "410px",
        width: "100%",
        padding: "5px",
        marginBottom: "10px",
        marginRight: "0px",
      }}
    >
      <Typography
        style={{
          color: "#0b6471",
          fontSize: "16px",
          fontWeight: "100",
          borderBottom: "0px solid",
          paddingLeft: "10px",
          paddingTop: "5px",
        }}
      >
        ANALIZA KOSZTU OSOBODNIA
      </Typography>

      <TableContainer>
        <Table size="small" style={{ width: "100%" }}>
          <TableHead>
            <TableRow>
              <TableCell
                style={{
                  color: "#0b6471",
                  fontSize: "16px",
                  fontWeight: "100",
                  width: '20px',
                  paddingRight: '0px',
                  paddingLeft: '0px'
                }}
              >

              </TableCell>
              <TableCell
                style={{
                  color: "#0b6471",
                  fontSize: "16px",
                  fontWeight: "100",
                }}
              >
                Kod
              </TableCell>
              <TableCell
                style={{
                  color: "#0b6471",
                  fontSize: "16px",
                  fontWeight: "100",
                }}
              >
                Nazwa
              </TableCell>
              <TableCell
                align="right"
                style={{
                  color: "#0b6471",
                  fontSize: "16px",
                  fontWeight: "100",
                  width: '250px',
                }}
              >
                Ilość osobodni
              </TableCell>

              <TableCell
                align="right"
                style={{
                  color: "#0b6471",
                  fontSize: "16px",
                  fontWeight: "100",
                  width: '250px',
                }}
              >
                Koszt
              </TableCell>

              <TableCell
                align="right"
                style={{
                  color: "#0b6471",
                  fontSize: "16px",
                  fontWeight: "100",
                  width: '250px',
                }}
              >
                Koszt osobodnia
              </TableCell>


            </TableRow>
          </TableHead>
          <TableBody>
            {row &&
              row
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((child) => (
                  <Fragment>
                    <TableRow key={child.id} hover="true">
                      <TableCell
                        onClick={() => switchExpandedState(child.id)}
                        style={{
                          paddingRight: '0px',
                          paddingLeft: '0px',
                          paddingTop: '9px',
                          paddingBottom: '6px',
                          borderBottom: expandedRows.includes(child.id) && child.children && child.children.length !== 0 && 'none'
                        }}>
                        <ExpandIcon style={{ rotate: expandedRows.includes(child.id) ? '0deg' : '-90deg', }} />
                      </TableCell>
                      <TableCell
                        style={{
                          borderBottom: expandedRows.includes(child.id) && child.children && child.children.length !== 0 && 'none'
                        }}
                      >
                        {child.id}
                      </TableCell>
                      <TableCell>
                        {child.OPK_name}
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <InLineChart id={child.id} data={child.monthly.map(m => m.hospital_days)} />
                          {child.hospital_days.toLocaleString("pl-PL", {
                            maximumFractionDigits: 0,
                          })}
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <InLineChart id={child.id} data={child.monthly.map(m => m.cost)} />
                          {child.cost.toLocaleString("pl-PL", {
                            maximumFractionDigits: 2, minimumFractionDigits: 2,
                          })}
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ display: 'flex', justifyContent: 'space-between', color: child.costPerDay > 0 ? 'black' : '#FE8E3C' }}>
                          <InLineChart id={child.id} data={child.monthly.map(m => m.costPerDay)} />
                          {child.costPerDay.toLocaleString("pl-PL", {
                            maximumFractionDigits: 2, minimumFractionDigits: 2,
                          })}
                        </div>
                      </TableCell>
                    </TableRow>
                    {
                      expandedRows.includes(child.id) && child.children && Array.isArray(child.children)
                      &&
                      child.children.map(l1child =>
                        <Fragment>
                          <TableRow key={'L1_+'.concat(child.id).concat(l1child.id)} hover="true">
                            <TableCell
                              style={{
                                paddingRight: '0px',
                                paddingLeft: '0px',
                              }}>
                            </TableCell>
                            <TableCell
                              onClick={() => switchExpandedState(child.id + '-' + l1child.id)}
                              style={{
                                paddingRight: '0px',
                                paddingLeft: '10px',
                                paddingTop: '9px',
                                paddingBottom: '6px',
                                borderBottom: expandedRows.includes(child.id + '-' + l1child.id) && l1child.children && l1child.children.length !== 0 && 'none'
                              }}>
                              <ExpandIcon style={{ rotate: expandedRows.includes(child.id + '-' + l1child.id) ? '0deg' : '-90deg', }} />
                            </TableCell>
                            <TableCell>
                              {l1child.id}
                            </TableCell>
                            <TableCell align="right">

                            </TableCell>
                            <TableCell align="right">
                              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <InLineChart id={l1child.id} data={l1child.monthly.map(m => m.cost)} />
                                {l1child.cost.toLocaleString("pl-PL", {
                                  maximumFractionDigits: 2, minimumFractionDigits: 2,
                                })}
                              </div>
                            </TableCell>
                            <TableCell align="right">
                              <div style={{ display: 'flex', justifyContent: 'space-between', color: l1child.costPerDay > 0 ? 'black' : '#FE8E3C' }}>
                                <InLineChart id={l1child.id} data={l1child.monthly.map(m => m.costPerDay)} />
                                {l1child.costPerDay.toLocaleString("pl-PL", {
                                  maximumFractionDigits: 2, minimumFractionDigits: 2,
                                })}
                              </div>
                            </TableCell>
                          </TableRow>
                          {
                            expandedRows.includes(child.id + '-' + l1child.id) && l1child.children && Array.isArray(l1child.children)
                            &&
                            l1child.children.map(l2child =>
                              <TableRow key={'L2_+'.concat(child.id).concat(l1child.id).concat(l2child.id)} hover="true">
                                <TableCell
                                  style={{
                                    paddingRight: '0px',
                                    paddingLeft: '0px',
                                  }}>
                                </TableCell>
                                <TableCell>
                                </TableCell>
                                <TableCell>
                                  {l2child.id}
                                </TableCell>
                                <TableCell align="right">

                                </TableCell>
                                <TableCell align="right">
                                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <InLineChart id={l2child.id} data={l2child.monthly.map(m => m.cost)} />
                                    {l2child.cost.toLocaleString("pl-PL", {
                                      maximumFractionDigits: 2, minimumFractionDigits: 2,
                                    })}
                                  </div>
                                </TableCell>
                                <TableCell align="right">
                                  <div style={{ display: 'flex', justifyContent: 'space-between', color: l2child.costPerDay > 0 ? 'black' : '#FE8E3C' }}>
                                    <InLineChart id={l2child.id} data={l2child.monthly.map(m => m.costPerDay)} />
                                    {l2child.costPerDay.toLocaleString("pl-PL", {
                                      maximumFractionDigits: 2, minimumFractionDigits: 2,
                                    })}
                                  </div>
                                </TableCell>
                              </TableRow>
                            )
                          }
                        </Fragment>

                      )
                    }
                  </Fragment>
                ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[20, 50, 100]}
          component="div"
          count={row && row.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Paper>
  );
}

export default function Report028() {
  const [reportDataLoaded, setReportDataLoaded] = React.useState(false);
  const [reportData, setReportData] = React.useState(null);
  const [filtersLoaded, setFiltersLoaded] = React.useState(false);
  const [dateList, setDateList] = React.useState([]);
  const [startDate, setStartDate] = React.useState(null);
  const { getAccessTokenSilently, user } = useAuth0();
  const sortByOptions = [
    { id: 'id', name: 'Kod', direction: 'Malejąco' },
    { id: 'OPK_name', name: 'Nazwa', direction: 'Malejąco' },
    { id: 'hospital_days', name: 'Ilość osobodni', direction: 'Malejąco' },
    { id: 'cost', name: 'Koszt', direction: 'Malejąco' },
    { id: 'costPerDay', name: 'Koszt osobodnia', direction: 'Malejąco' },
    { id: 'id', name: 'Kod', direction: 'Rosnąco' },
    { id: 'OPK_name', name: 'Nazwa', direction: 'Rosnąco' },
    { id: 'hospital_days', name: 'Ilość osobodni', direction: 'Rosnąco' },
    { id: 'cost', name: 'Koszt', direction: 'Rosnąco' },
    { id: 'costPerDay', name: 'Koszt osobodnia', direction: 'Rosnąco' },
  ];
  const [sortBy, setSortBy] = React.useState(sortByOptions[4]);
  const [reportInfoOpen, setReportInfoOpen] = React.useState(false);

  const menuItems = [
    {
      "id": "401-02-01",
      "name": "401-02-01 - Leki (za wyjątkiem programów lekowych oraz leków do chemioterapii)"
    },
    {
      "id": "401-02-02",
      "name": "401-02-02 - Leki do programów lekowych, leki do chemioterapii"
    },
    {
      "id": "401-02-03",
      "name": "401-02-03 - Inne leki",
      "children": [
        {
          "id": "401-02-03-01",
          "name": "401-02-03-01 - Leki recepturowe"
        },
        {
          "id": "401-02-03-02",
          "name": "401-02-03-02 - Krew i produkty krwiopochodne"
        },
        {
          "id": "401-02-03-03",
          "name": "401-02-03-03 - Radiofarmaceutyki"
        },
        {
          "id": "401-02-03-04",
          "name": "401-02-03-04 - Kontrasty "
        },
        {
          "id": "401-02-03-05",
          "name": "401-02-03-05 - Preparaty do żywienia pozajelitowego, dojelitowego"
        },
        {
          "id": "401-02-03-06",
          "name": "401-02-03-06 - Preparaty przeciwkrwotoczne miejscowe i uszczelniające"
        },
        {
          "id": "401-02-03-07",
          "name": "401-02-03-07 - Pozostałe leki "
        }
      ]
    },
    {
      "id": "401-02-04",
      "name": "401-02-04 - Materiały medyczne ",
      "children": [
        {
          "id": "401-02-04-01",
          "name": "401-02-04-01 - Narzędzia chirurgiczne i inne"
        },
        {
          "id": "401-02-04-02",
          "name": "401-02-04-02 - Jednorazowe staplery i zszywki"
        },
        {
          "id": "401-02-04-03",
          "name": "401-02-04-03 - Igły, strzykawki, wenflony"
        },
        {
          "id": "401-02-04-04",
          "name": "401-02-04-04 - Materiały szewne, w szczególności nici chirurgiczne "
        },
        {
          "id": "401-02-04-05",
          "name": "401-02-04-05 - Obłożenia i podkłady jednorazowe, w szczególności zestawy"
        },
        {
          "id": "401-02-04-06",
          "name": "401-02-04-06 - Bielizna i pościel jednorazowa"
        },
        {
          "id": "401-02-04-07",
          "name": "401-02-04-07 - Odzież ochronna jednorazowa"
        },
        {
          "id": "401-02-04-08",
          "name": "401-02-04-08 - Rękawice jednorazowe"
        },
        {
          "id": "401-02-04-09",
          "name": "401-02-04-09 - Środki opatrunkowe "
        },
        {
          "id": "401-02-04-10",
          "name": "401-02-04-10 - Niewszczepialny jednorazowy sprzęt i niewszczepialne wyroby medyczne"
        },
        {
          "id": "401-02-04-11",
          "name": "401-02-04-11 - Wszczepialne wyroby medyczne "
        },
        {
          "id": "401-02-04-12",
          "name": "401-02-04-12 - Gazy medyczne (tlen, azot i inne) "
        },
        {
          "id": "401-02-04-13",
          "name": "401-02-04-13 - Środki dezynfekcyjne"
        },
        {
          "id": "401-02-04-14",
          "name": "401-02-04-14 - Odczynniki i testy do badań diagnostycznych"
        },
        {
          "id": "401-02-04-15",
          "name": "401-02-04-15 - Pozostałe materiały medyczne do badań diagnostycznych"
        },
        {
          "id": "401-02-04-16",
          "name": "401-02-04-16 - Pozostały jednorazowy sprzęt i materiały medyczne "
        },
        {
          "id": "401-02-04-17",
          "name": "401-02-04-17 - Pozostały sprzęt i materiały medyczne wielokrotnego użytku"
        }
      ]
    }
  ];

  const [activeAccounts, setActiveAccounts] = React.useState([]);

  const applyAccountsFilter = async (accounts) => {
    setReportDataLoaded(false);

    const token = await getAccessTokenSilently();
    let apiUrl = `${apiurl}/costperhdaccounts`;
    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(
        {
          "command": "update",
          "data": JSON.stringify(accounts)
        })
    };
    let res = await fetch(apiUrl, requestOptions);
    loadData(startDate.year);
    setActiveAccounts(accounts);
    //setReportDataLoaded(true);
  };

  const loadData = (year) => {
    setReportDataLoaded(false);
    getAccessTokenSilently().then((token) => {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      fetch(`${apiurl}/costperday/${year}/json`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          setReportData(data);
          setReportDataLoaded(true);
        });
    });
  }

  function SortByBox(props) {
    return (
      <Autocomplete
        id="combo-box1"
        //disabled={!props.data}
        options={sortByOptions}
        value={sortBy}
        size="small"
        disableClearable
        autoHighlight
        getOptionLabel={(option) => option.name}
        groupBy={option => option.direction}
        getOptionSelected={(option, value) => {
          if (!value) return false;
          return option.id === value.id && option.direction === value.direction;
        }}
        style={{ width: "220px", marginBottom: "10px", marginLeft: '10px', marginRight: '10px' }}
        renderInput={(params) => <TextField {...params} label="Sortowanie według" />}
        onChange={(event, value) => {
          if (value) {
            setSortBy(value);
            //if (activeYard) loadData(activeYard, value.year);
          }
        }}
      />
    );
  }

  function DateBox(props) {
    return (
      <Autocomplete
        id="combo-box"
        disabled={!props.data}
        options={props.data}
        value={startDate}
        size="small"
        disableClearable
        autoHighlight
        getOptionLabel={(option) => option.year && option.year.toLocaleString()}
        defaultValue={null}
        getOptionSelected={(option, value) => {
          if (!value) return false;
          return option.year.toLocaleString() === value;
        }}
        style={{ width: "80px", marginBottom: "10px", marginLeft: '10px', marginRight: '10px' }}
        renderInput={(params) => <TextField {...params} label="Rok" />}
        onChange={(event, value) => {
          if (value) {
            setStartDate(value);
            loadData(value.year);
          }
        }}
      />
    );
  }


  const loadFiltersNew = () => {
    const doDataFetch = async () => {
      setFiltersLoaded(false);
      const token = await getAccessTokenSilently();

      //active HD cost accounts
      let apiUrl = `${apiurl}/costperhdaccounts`;
      let requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(
          {
            "command": "get"
          })
      };
      let res = await fetch(apiUrl, requestOptions);
      let fetchedData = await res.json();
      setActiveAccounts(fetchedData);

      //available years
      apiUrl = `${apiurl}/yearslist`;
      requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      res = await fetch(apiUrl, requestOptions);
      fetchedData = await res.json();
      setDateList(fetchedData.datelist);
      if (fetchedData.datelist && fetchedData.datelist.length !== 0) {
        setStartDate(fetchedData.datelist[fetchedData.datelist.length - 1]);
        setFiltersLoaded(true);
        loadData(fetchedData.datelist[fetchedData.datelist.length - 1].year);
      };

    };

    doDataFetch();
  };

  React.useEffect(() => {
    let mounted = true;
    //console.log("Main mounted");
    loadFiltersNew();
    return function cleanup() {
      //console.log("Main unmounted");
      mounted = false;
    };
  }, []);

  const downloadFile = (downloadURL) => {

    getAccessTokenSilently().then((token) => {
      document.body.style.cursor = 'wait';
      const apiUrl = downloadURL
      fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => response.blob())
        .then((blob) => {
          // Create blob link to download
          const url = window.URL.createObjectURL(
            new Blob([blob]),
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `Raport kosztów osobodni.xlsx`,
          );
          // Append to html link element page
          document.body.appendChild(link);
          // Start download
          link.click();
          // Clean up and remove the link
          link.parentNode.removeChild(link);
          document.body.style.cursor = 'auto';
        });
    });

  };

  const [videoListOpen, setVideoListOpen] = React.useState(false);
  const [videoPlayDialogOpen, setVideoPlayDialogOpen] = React.useState(false);
  const [selectedVideo, setSelectedVideo] = React.useState(undefined);

  const handleVideoListClose = () => {
    setVideoListOpen(false)
  };
  const videoData = [
    {
      image: '/manual/reports/Raport_Koszt_osobodnia.jpg',
      video: '/manual/reports/Raport_Koszt_osobodnia.mp4'
    }
  ];

  const handleVideoSelect = (video) => {
    setSelectedVideo(video);
    setVideoListOpen(false);
    setVideoPlayDialogOpen(true);
  };

  const VideoList = () => {
    return <div>
      {
        videoData.map(
          (v, i) => {
            return <div className="videoListItem" onClick={() => handleVideoSelect(v)}>
              <div style={{ position: 'relative' }}>
                <img src={v.image} alt={'Video nr ' + i} />
                <div style={{
                  position: 'absolute',
                  top: '90px',
                  left: '190px',
                  opacity: '.5',
                  color: 'gray'
                }}>
                  <PlayIcon />
                </div>
              </div>
            </div>
          }
        )
      }
    </div>
  }


  return (
    <div className="App" style={{ position: "relative" }}>
      <div
        style={{
          background: "linear-gradient(to right, #0b6471, #9BC0C5)",
          display: "flex",
          height: "65px",
          width: "100%",
          backgroundColor: "#0b6471",
          color: "white",
          borderRadius: "5px",
          paddingTop: "0px",
          paddingLeft: "0px",
          alignItems: "center",
        }}
      >
        <div style={{ width: "80px", marginTop: "5px" }}>
          <PollIcon
            style={{
              marginLeft: "20px",
              marginRight: "20px",
              fontSize: "42px",
            }}
          />
        </div>
        <div>
          <Typography variant="h5" style={{ color: "white" }}>
            Ranking kosztu osobodnia
          </Typography>

        </div>
      </div>
      <p style={{ height: "5px" }} />
      {filtersLoaded ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            position: "relative",
            width: "100%",
          }}
        >
          <DateBox data={dateList} />
          <AccountFilter
            titleCaption="Konta 401-02"
            menuData={menuItems}
            startSelection={activeAccounts}
            updateFunction={applyAccountsFilter}
          />
          <SortByBox />
          <MUITooltip title='Instrukcje video'>
                <div style={{ height: '36px', marginLeft: '10px', marginRight: '5px', paddingTop: '14px' }}
                  onClick={
                    () => {
                      setSelectedVideo(videoData[0]);
                      setVideoPlayDialogOpen(true);
                    }
                  }>
                  <VideoIcon style={{ margin: '0px', cursor: 'pointer' }}></VideoIcon>
                </div>
              </MUITooltip>          
          <MUITooltip title='Opis raportu'>
            <LibraryIcon
              id='reportInfoIcon'
              onClick={() => setReportInfoOpen(true)}
              style={{ marginTop: '15px', marginRight: '5px', cursor: 'pointer', width: '22px', height: '22px', fill: '#0b6471' }}
            />
          </MUITooltip>
          <MUITooltip title='Pobierz raport jako plik MS Excel'>
            <XlsxIcon
              style={{ marginTop: '15px', cursor: 'pointer', width: '22px', height: '22px', fill: '#0b6471' }}
              onClick={
                () => downloadFile(`${apiurl}/costperday/${startDate.year}/xlsx`)
              }
            />
          </MUITooltip>

        </div>
      ) : (
        <div>List not yet loaded</div>
      )}
      <p style={{ height: "5px" }} />

      {reportData ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            overflow: "auto",
            transition: "opacity 0.5s",
            opacity: reportDataLoaded ? "1" : "0.2",
          }}
        >

          <ProceduresSummary row={reportData.sort((a, b) => (a[sortBy.id] > b[sortBy.id]) ? (sortBy.direction[0] === 'R' ? 1 : -1) : (sortBy.direction[0] === 'R' ? -1 : 1))} />


        </div>
      ) : (
        (
          <Typography
            style={{
              position: "absolute",
              top: "120%",
              left: "40%",
              color: "#0b6471",
              textJustify: "left",
            }}
            variant="h5"
          >
            Brak danych
          </Typography>
        )
      )}
      {!reportDataLoaded && (
        <CircularProgress
          style={{
            position: "absolute",
            height: "70px",
            width: "70px",
            top: reportData ? "50%" : "120%",
            left: "50%",
            color: "#0b6471",
            opacity: "0.6",
          }}
        />
      )}
      <Popover
        id='hintPopOver'
        open={reportInfoOpen}
        anchorEl={document.getElementById('reportInfoIcon')}
        onClose={() => setReportInfoOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
      >
        <Paper
          style={{
            padding: "10px",
            width: "600px",
            fontFamily: "roboto",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <div
            style={{
              top: "0px",
              display: "flex",
              width: "100%",
              justifyContent: "right"
            }}
          >
            <CloseIcon style={{ cursor: 'pointer', fontSize: '16px' }} onClick={() => setReportInfoOpen(false)} />
          </div>
          <div style={{ fontSize: '16px', padding: '5px', marginBottom: '5px' }}>
            <p>
              Raport zawiera <b>koszty osobodni</b> w podziale na miesiące.
            </p>
            <p>
              Jak liczony jest koszt osobodnia na oddziale?
            </p>
            <p>
              W koszcie osobodnia <b>uwzględnione są</b>:
            </p>
            <ul>
              <li>
                koszty bezpośrednie z <b>I etapu</b> alokacji kosztów (bez kosztów zaksięgowanych na kontach z grupy „401-02*”)
                <br />
                <font style={{ color: '#FE8E3C', fontWeight: 'bold' }}>UWAGA:</font> użytkownik ma możliwość zaznaczenia, które konta z grupy "401-02*" mają jednak być uwzględnione w wyliczeniu kosztu osobodnia
              </li>
              <li>doliczone koszty komórek pomocniczych (530, 535) z <b>II etapu</b> alokacji kosztów,</li>
              <li>doliczone koszty zarządu (550) z <b>IV etapu</b> alokacji kosztów.</li>
            </ul>
            <p>
              W koszcie osobodnia <b>nie są uwzględnione</b>:
            </p>
            <ul>
              <li>doliczone koszty procedur (507) z <b>III etapu</b> alokacji kosztów,</li>
              <li>
                koszty zaksięgowane na kontach z grupy <b>„401-02*”</b>.
                <br />
                <font style={{ color: '#FE8E3C', fontWeight: 'bold' }}>UWAGA:</font> użytkownik ma możliwość zaznaczenia, które konta z grupy "401-02*" mają jednak być uwzględnione w wyliczeniu kosztu osobodnia
              </li>
            </ul>
          </div>
          <div
            style={{
              top: "60px",
              display: "flex",
              justifyContent: "flex-end",
              borderTop: '1px #0B6471 solid'
            }}
          >
            <Button onClick={() => setReportInfoOpen(false)}>
              Zakończ
            </Button>
          </div>
        </Paper>
      </Popover>
      <Dialog

        maxWidth='90vw'
        open={videoPlayDialogOpen}
        onClose={() => setVideoPlayDialogOpen(false)}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"

      >
        <DialogContent style={{ display: 'flex', flexDirection: 'column', margin: '0px', padding: '0px' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '3px 10px 3px 0px' }}>
            <button
              onClick={() => {
                const div = document.getElementById('videoControl');
                if (div.requestFullscreen)
                  div.requestFullscreen();
                else if (div.webkitRequestFullscreen)
                  div.webkitRequestFullscreen();
                else if (div.msRequestFullScreen)
                  div.msRequestFullScreen();
              }
              }
              style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
            >
              Pełen ekran
            </button>
            <button
              onClick={() => setVideoPlayDialogOpen(false)}
              style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
            >
              Zamknij
            </button>
          </div>
          <video id='videoControl' controls autoPlay style={{ width: '80vw' }}>
            <source src={selectedVideo && selectedVideo.video} type="video/mp4" />
            Video control not supported by browser
          </video>

        </DialogContent>
      </Dialog>

    </div>
  );
}
